import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';
import { PaymentRoutingModule } from './payment-routing.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, PaymentRoutingModule, SharedModule],
})
export class PaymentModule {}
